module.exports = __webpack_public_path__ + "img/claribel.3fbef4bf.webp";